import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { mapValues, keyBy } from 'lodash'
import Button from 'components/theme/Button'
import Select from 'components/theme/Select'
import { addContactsToGroup } from '../../actions/contacts/groups'
import { contactsNotInGroupSelector } from '../../selectors'
import ActionType from '../../actions/ActionType'
import language from 'utils/vast-languagepack'
// import { omit } from 'lodash'

const mapStateToProps = (state, { groupID }) => {
	// const contactsNotInGroup = omit(
	// 	state.contacts.contactsWithEmailsByID,
	// 	Object.keys(state.contacts.groupsByID?.[groupID]?.memberIDs) || [],
	// )

	return {
		groupID,
		contactsNotInGroup: contactsNotInGroupSelector(state),
		// contactsNotInGroup: state.contacts.contactsWithEmailsByID,
		selectValue: state.contacts.contactsToAddToGroupSelectValue,
	}
}

const mapDispatchToProps = (dispatch) => {
	const { Contacts } = ActionType
	const dispatchType = (type, payload) => (dispatch) =>
		dispatch({ type, payload })
	return bindActionCreators(
		{
			addContactsToGroup,
			handleMultiChange: (newValue) =>
				dispatchType(Contacts.GROUP_SELECT_VALUE_CHANGE, newValue),
		},
		dispatch,
	)
}

class AddContactSelect extends Component {
	handleSelectSubmit = () => {
		const { addContactsToGroup, handleMultiChange, selectValue, groupID } =
			this.props

		addContactsToGroup(
			mapValues(
				keyBy(selectValue, (el) => el.contactID),
				() => true,
			),
			groupID,
		)

		handleMultiChange([])
	}

	render() {
		const { handleMultiChange, selectValue, contactsNotInGroup, groupID } =
			this.props

		const contactsOptions = Object.keys(contactsNotInGroup).map((id) => {
			const contact = contactsNotInGroup[id]
			let label = ''
			if (contact.first_name && contact.last_name)
				label = `${contact.first_name} ${contact.last_name}`
			else if (contact.email && contact.email.length)
				label = contact.email[0].address
			else if (contact.phones && contact.phones.length)
				label = contact.phones[0].number
			else label = 'No name, email or phone for this contact.'
			return {
				contactID: contact.id,
				value: contact.id,
				label: label,
				key: `${contact.id}SelectValue`,
			}
		})

		return (
			<>
				<div
					style={{
						marginBottom: '5px',
						width: 'calc(100% - 105.33px)',
					}}
				>
					<Select
						value={selectValue}
						onChange={(newValue) => handleMultiChange(newValue)}
						closeMenuOnSelect={false}
						isMulti
						options={contactsOptions}
						placeholder={language.groups.placeholder.contactToGroupPlaceholder}
					/>
				</div>
				<Button
					disabled={groupID === 'new' || !selectValue.length}
					variant="contained"
					color="secondary"
					style={{
						position: 'absolute',
						top: '50%',
						transform: 'translate(0, -50%)',
						right: 0,
					}}
					onClick={this.handleSelectSubmit}
				>
					{language.groups.submit}
				</Button>
			</>
		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AddContactSelect)
